import * as React from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { compose, mapProps } from 'recompose';

import SvgIcon from 'src/components/SvgIcon';

import './styles.scss';

interface ICloseButtonProps {
  closeToast?: () => void;
}

const CloseButton: React.FunctionComponent<ICloseButtonProps> = ({ closeToast }) => {
  return (
    <button type="button" onClick={closeToast} className="Toastify__close">
      <SvgIcon iconName="close" iconWidth={16} iconHeight={16} />
    </button>
  );
};

const enhance = compose(
  mapProps(
    (props: any): ToastContainerProps => {
      return {
        closeButton: <CloseButton />,
        hideProgressBar: true,
        autoClose: 3000,
        ...props,
      };
    },
  ),
);

export default enhance(ToastContainer);



// WEBPACK FOOTER //
// ./src/containers/App/Toastify/index.tsx